<template>
    <el-dialog title="重命名" :visible.sync="dialogVisible" width="292px" custom-class="name-dialog">
        <el-input v-model="input" placeholder="请输入内容" maxlength="32"></el-input>
        <span slot="footer" class="dialog-footer">
            <div class="btn-item btn-item2" @click="changeName">确定</div>
            <div class="btn-item" @click="dialogVisible = false">取消</div>
        </span>
        <Msg ref="tsmsg"></Msg>
    </el-dialog>
</template>

<script>
import Msg from '@/components/msg.vue' //信息提示组件
export default {
    components: { Msg },
    data() {
        return {
            dialogVisible: false,
            input: "",
            thisItem: null,
        }
    },
    methods: {
        open(item) {
            this.thisItem = item
            this.input = item.sceneName
            this.dialogVisible = true;
        },
        changeName() {
            if (!this.input.length) {
                this.$refs.tsmsg.msgShow("请输入场景名称", 1.5)
                return
            }
            this.$http.postAction(this.$api.cloudsceneupdatename + "?id=" + this.thisItem.id + "&sceneName=" + this.input).then((res) => {
                let result = {
                    resultObj: res,
                    item: this.thisItem
                }
                result.item.sceneName = this.input
                this.$emit("change", result)
                if (res.code == 200) {
                    this.dialogVisible = false;
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
::v-deep .name-dialog {
    position: absolute;
    margin: 0 !important;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    border-radius: .15rem !important;

    .el-dialog__header {
        padding: 0;
        height: .6rem;
        box-sizing: border-box;
        border-bottom: 1px solid #F1F3F8;
        display: flex;
        align-items: center;
        text-align: left;
        padding-left: .2125rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #333333;

        .el-dialog__headerbtn {
            top: 7px;
            right: 15px;
            font-size: 22px;
        }
    }

    .dialog-footer {
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .btn-item {
            cursor: pointer;
            margin: 0 .125rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: Microsoft YaHei;
            font-weight: 400;
            font-size: .175rem;
            color: #666666;
            width: .9875rem;
            height: .4625rem;
            border-radius: .1rem;
            border: 1px solid #999999;
            box-sizing: border-box;
        }

        .btn-item2 {
            border-color: #2DAEA9;
            background: #2DAEA9;
            color: #FEFFFF;
        }
    }
}
</style>